import React from 'react';

// Components
import ConfigurationCycleList from '../ConfigurationCycleList/ConfigurationCycleList';
import ConfigurationCycleTags from '../ConfigurationCycleTags/ConfigurationCycleTags';

export type ConfigurationCycleOption = { name: string, value: string };

type ComponentProps = {
  disabled?: boolean;
  editingController?: string | null;
  layout?: 'list' | 'tags';
  listOptions: ConfigurationCycleOption[];
  name?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  selectAllOptions: (data: ConfigurationCycleOption[]) => void;
  resetAllOptions: (data: ConfigurationCycleOption[]) => void;
  selectedValues?: string[] | null;
  title: string;
  updateEditingController?: (controller: string) => void;
};

const ConfigurationCycle: React.FC<ComponentProps> = ({
  disabled = false,
  editingController,
  layout = 'list',
  listOptions,
  name,
  onChange,
  selectAllOptions,
  resetAllOptions,
  selectedValues = null,
  title,
  updateEditingController,
}) => {

  return (
    <div className="с-configuration-cycle flex w-full flex-auto flex-col">
      <h5 className="с-configuration-cycle__name pb-4 text-center text-lg text-black dark:text-white truncate">
        {title}
      </h5>
      {layout === 'tags' ? (
        <ConfigurationCycleTags
          listOptions={listOptions}
          selectedValues={selectedValues}
          onChange={onChange}
          disabled={disabled}
          selectAllOptions={selectAllOptions}
          resetAllOptions={resetAllOptions}
        />
      ) : (
        <ConfigurationCycleList
          dataName={name}
          listOptions={listOptions}
          selectedValues={selectedValues}
          onChange={onChange}
          disabled={disabled}
          editingController={editingController}
          updateEditingController={updateEditingController}
          selectAllOptions={selectAllOptions}
          resetAllOptions={resetAllOptions}
        />
      )}
    </div>
  );
};

export default ConfigurationCycle;
